import { formReveal } from '../utilities/_helpers.js';

document.addEventListener('DOMContentLoaded', () => {
  formReveal([{ block: '.content-image', contentSelector: '.content-holder' }]);
});
